
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabsforcorporatepicnic() {



const cardData =
{
  keyword: 'Cabs for Corporate Picnic in Pune',
  heading: 'eTravo: Comfortable and Reliable Cabs for Corporate Picnic in Pune',
  headingDescription: 'Planning a corporate picnic in or around Pune? eTravo offers fully-equipped, air-conditioned cabs designed to make your team outings smooth, enjoyable, and stress-free. Whether it’s a one-day staff picnic, an annual team-building event, or a weekend getaway for your employees, our cab services ensure seamless group travel with trained drivers, real-time tracking, and on-time pickups. From executive sedans to spacious Innovas and group-friendly SUVs, our fleet caters to every need. Trust eTravo for safe, comfortable, and organized picnic transportation for your workforce.',

  top: 'Top Picnic Spots Around Pune Covered by eTravo Corporate Cabs',
  topPlaces: [
    {
      title: 'Sinhagad Fort',
      description: 'A favorite one-day getaway near Pune, Sinhagad Fort offers breathtaking views, historic trails, and cool mountain air. eTravo’s picnic cabs ensure your team reaches comfortably with multiple pickup options across the city, onboard water, and music for a fun ride.'
    },
    {
      title: 'Mulshi Dam',
      description: 'A scenic picnic destination surrounded by lush greenery and lakeside views. Ideal for relaxing employee picnics or nature retreats, our AC cabs make the 2-hour journey from Pune relaxing with ample luggage space and rest stops as needed.'
    },
    {
      title: 'Panshet Lake',
      description: 'Perfect for water-side picnics and group games, Panshet Lake is often chosen by corporates for day retreats. Our cab service to Panshet includes early morning pickups, breakfast stops, and a comfortable return journey even after sunset.'
    },
    {
      title: 'Rajmachi Point Lonavala',
      description: 'Located around 2 hours from Pune, Rajmachi is a serene hilltop location, ideal for team bonding. Our spacious group cabs handle bumpy routes with ease, and we ensure safe driving through the ghats and return before dark.'
    },
    {
      title: 'Mantra Resort (Bhatghar Dam Road)',
      description: 'A full-service picnic resort with activities, food, and entertainment. Our dedicated cab services include roundtrip bookings, pickup coordination for large teams, and wait-and-return options for HR teams managing group logistics.'
    },
    {
      title: 'Empress Botanical Garden',
      description: 'Located in the heart of Pune, this is ideal for quick and local team picnics. Our cabs ensure early arrival for setting up activities, and pickup/drop-off can be organized for employees from multiple offices or locations.'
    },
    {
      title: 'Lavasa City',
      description: 'A popular choice for upscale corporate outings, Lavasa offers lakeside fun, adventure sports, and open-air meeting zones. eTravo’s premium cab services provide a hassle-free journey along the winding hill roads with optional late evening return trips.'
    },
    {
      title: 'Khadakwasla Backwaters',
      description: 'A calm riverside destination just 45 minutes from Pune. Popular for potluck-style picnics and informal team games. We manage point-to-point travel with cab options for small and mid-sized staff groups.'
    },
    {
      title: 'Gram Sanskruti Udyan',
      description: 'Ideal for teams looking to explore rural culture with a relaxing picnic atmosphere. Located in Pashan, eTravo provides easy local travel support with short-distance cabs available by the hour or day.'
    },
    {
      title: 'Peacock Bay (Khadakwasla)',
      description: 'A scenic and lesser-known picnic spot managed by the NDA. eTravo handles special permission timing coordination along with safe and professional travel for employee groups headed here.'
    }
  ],

  services: [
    {
      name: 'Pune Corporate Picnic Cab Hire',
      description: 'Plan a smooth and coordinated team picnic with our full-day cab rental service. We offer air-conditioned vehicles, punctual pickups, and experienced drivers who are familiar with the best picnic routes and stops around Pune.'
    },
    {
      name: 'Staff Picnic Cab Rentals Pune',
      description: 'Our cab rental packages are tailored for employee group outings, with vehicles ranging from 4 to 7 seaters available on a per-day or multi-location basis. Perfect for transporting staff from multiple locations to a single picnic spot.'
    },
    {
      name: 'Affordable Cabs for Corporate Outings Pune',
      description: 'We provide cost-effective group cab solutions without compromising on comfort. Choose from cab pools or full cab hires based on team size and budget, complete with route planning and fuel-inclusive pricing.'
    },
    {
      name: 'AC Cab Service for Corporate Picnic Pune',
      description: 'All our cabs come with functional air-conditioning, plush seats, and interiors suitable for leisure travel. Whether you’re heading to a nearby lake or a hilly retreat, our vehicles ensure your staff enjoys the journey as much as the destination.'
    },
    {
      name: 'Employee Picnic Transport Pune',
      description: 'Specially designed cab services for large corporate picnics involving more than one pickup point, early morning departures, and coordinated returns. Includes support staff at dispatch if required for on-ground HR coordination.'
    },
    {
      name: 'Business Picnic Cab Rentals Pune',
      description: 'Perfect for medium and small teams looking for private vehicle rentals for business leisure activities. Our cabs are available for single-day use or full-weekend hire depending on the outing plan.'
    },
    {
      name: 'Corporate Event Cabs Pune',
      description: 'Hosting a team-building event at a resort or outdoor venue? eTravo offers door-to-venue and back cab services with multiple route options, safety checks, and standby vehicles in case of delays.'
    },
    {
      name: 'Reliable Picnic Cabs Pune',
      description: 'Punctual pickups, background-verified drivers, and fully serviced cabs make our picnic rides highly reliable. Our customer support remains available throughout the day to handle reschedules or extended plans.'
    },
    {
      name: 'Group Cab Hire for Picnic Pune',
      description: 'We offer coordinated group cab rentals for teams, departments, or entire companies. Choose from a fleet of Innovas, SUVs, and Ertigas with backup cab support, in-ride entertainment options, and route flexibility.'
    },
    {
      name: 'Corporate Team Outing Cabs Pune',
      description: 'Cab services tailored for HR and admin teams organizing regular employee outings. Our plans include wait-and-return options, mileage limits, and flat-day pricing to make travel planning easy and budget-friendly.'
    },
    {
      name: 'Comfortable Corporate Picnic Travel Pune',
      description: 'We prioritize comfort with cab interiors designed for leisure—ample legroom, cushioned seating, clean interiors, and chilled air-conditioning that lasts through long day trips.'
    },
    {
      name: 'Picnic Day Cab Rentals Pune',
      description: 'Rent a cab for a single-day event with early pickups and fixed returns. Includes driver lunch provision, mid-day standby, and post-picnic drop-offs to multiple residential zones if required.'
    },
    {
      name: 'Corporate Picnic Shuttle Cabs Pune',
      description: 'For very large teams, we provide shuttle cab arrangements where multiple vehicles are coordinated to run in shifts — ideal for staggered arrival or exit schedules at event venues.'
    },
    {
      name: 'Cabs for Employee Excursions Pune',
      description: 'Whether it’s a department trip, a sales celebration, or a vendor day-out, our cabs are designed for comfort, coordination, and convenience. Packages include route customization and driver alignment with outing plans.'
    },
    {
      name: 'Staff Group Cab Hire Pune',
      description: 'Support group bookings for internal or cross-department outings with our fleet of MUVs and large AC cabs. We handle all communication between cab drivers and HR to streamline the travel experience.'
    }
  ],

  tableData: [
    ['Pune Corporate Picnic Cab Hire', 'Staff Picnic Cab Rentals Pune'],
    ['Affordable Cabs for Corporate Outings Pune', 'AC Cab Service for Corporate Picnic Pune'],
    ['Employee Picnic Transport Pune', 'Business Picnic Cab Rentals Pune'],
    ['Corporate Event Cabs Pune', 'Reliable Picnic Cabs Pune'],
    ['Group Cab Hire for Picnic Pune', 'Corporate Team Outing Cabs Pune'],
    ['Comfortable Corporate Picnic Travel Pune', 'Picnic Day Cab Rentals Pune'],
    ['Corporate Picnic Shuttle Cabs Pune', 'Cabs for Employee Excursions Pune'],
    ['Staff Group Cab Hire Pune', '']
  ],



"whychoose": [
    {
        "WhyChooseheading": "Specialized Cab Services for Corporate Picnics in Pune",
        "WhyChoosedescription": "eTravo provides reliable and well-coordinated cab services for corporate picnic outings, team bonding trips, and day-long getaways from Pune. Our services ensure a smooth start and end to your company’s fun day."
    },
    {
        "WhyChooseheading": "Fleet Options for Every Team Size",
        "WhyChoosedescription": "Whether you need sedans for small groups or multiple SUVs for departments, we offer a range of vehicles tailored for different team sizes, ensuring maximum comfort and convenience."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles for Long Rides",
        "WhyChoosedescription": "Our cabs are AC-enabled, spacious, and regularly cleaned—perfect for long-distance drives to picnic spots like Lonavala, Mulshi, Sinhagad, or Lavasa."
    },
    {
        "WhyChooseheading": "Punctual Pickups and Multi-Point Coordination",
        "WhyChoosedescription": "We provide timely pickups from office locations, residential areas, or company guest houses. Multiple pickup and drop points can be arranged to suit your team’s preferences."
    },
    {
        "WhyChooseheading": "Trained Drivers with Picnic Route Experience",
        "WhyChoosedescription": "Our drivers are courteous, punctual, and familiar with popular picnic destinations near Pune. They ensure safe and relaxed travel with minimal supervision required."
    },
    {
        "WhyChooseheading": "Customizable Packages with Fuel and Toll Inclusion",
        "WhyChoosedescription": "We offer day rental packages that include driver allowance, tolls, parking, and fuel—making it easy for your HR or admin team to budget the trip effectively."
    },
    {
        "WhyChooseheading": "Hygiene, Safety, and Music System for Fun Travel",
        "WhyChoosedescription": "Each cab is equipped with seat belts, first-aid kits, clean interiors, and an in-built music system—adding comfort and entertainment to the journey."
    },
    {
        "WhyChooseheading": "Transparent Billing and Picnic Transport Reports",
        "WhyChoosedescription": "Our picnic cab services come with GST-compliant invoices, detailed breakdowns, and easy-to-track receipts—ideal for internal approvals and reimbursement."
    }
]
}


const faqData = [
    [
        {
            question: 'What types of vehicles are available for corporate picnics?',
            answer: 'We offer sedans, SUVs, and MUVs like Innova Crysta and Ertiga—perfect for teams of 4 to 7 members per vehicle. Tempo travellers and mini buses are also available.'
        },
        {
            question: 'Can we plan pickups from multiple locations in Pune?',
            answer: 'Yes, we offer flexible route planning with multiple pickup and drop points as per your team’s residential or office locations.'
        },
        {
            question: 'Do you provide cabs for one-day round trip picnic outings?',
            answer: 'Absolutely. Our packages are designed for single-day events and include round-trip transport, fuel, tolls, and driver charges.'
        },
        {
            question: 'Is food or music allowed inside the cab?',
            answer: 'Yes, light snacks and music are allowed during the trip. All vehicles come with basic music systems and clean interiors to enhance the journey.'
        },
        {
            question: 'Do drivers know popular picnic routes around Pune?',
            answer: 'Yes, our drivers are experienced with picnic destinations like Lonavala, Lavasa, Mulshi, and Sinhagad, ensuring smooth and timely travel.'
        },
        {
            question: 'Will we get a GST invoice for the picnic cab rental?',
            answer: 'Yes, we provide GST-compliant digital invoices and complete cost breakdowns for easy company reimbursement and record keeping.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Ravindra Chitale',
        designation: 'HR Manager, Ascend Tech India',
        rating: [1, 1, 1, 1, 1],
        text: '“We hired 6 cabs from eTravo for our company’s Lavasa picnic. Everything was timely, clean, and professionally managed. The drivers were friendly too!”'
    },
    {
        name: 'Ms. Payal Wagh',
        designation: 'Admin Executive, iCore Digital',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo made our corporate picnic transport stress-free. From planning pickups to final drops, they handled everything with precision and care.”'
    }
];



















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cabs for Corporate Picnic in Pune",
  "image": "https://www.etravo.in/images/keyword/corporate-picnic-cab-pune.jpg",
  "description": "Hire cabs for corporate picnics in Pune with eTravo. Comfortable and affordable AC cabs for staff outings, corporate events, and group excursions. Reliable transport solutions for your corporate picnic needs.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7310"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1599",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cabs-for-corporate-picnic-pune"
  }
};









    return (
        <div>
<Helmet>
  <title>Cabs for Corporate Picnic in Pune | Staff Outing & Group Travel | eTravo</title>
  <meta 
    name="description" 
    content="Book affordable and reliable cabs for corporate picnics in Pune. AC cab services for staff outings, group trips, and corporate events with professional drivers by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabsforcorporatepicnic;